import React from 'react';
import { NavLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
//import "./style.css";
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import api from "./../../../services/api";
import SideNav from './../../../components/SideNav_PS';
import { user_token } from '../../../services/Auth';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);

export default class EditProntuario extends React.Component {

  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { id } = this.props.match.params;
    console.log(id);
    // const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
    const request = await apiProfessional.getExam(id);
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>
        <SideNav />
        <div id="top-PS">
          <Grid container spacing={0} direction="row" justify="left" alignItems="center" style={{ marginTop: '-35vh' }}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
              <NavLink id="voltar-a" to="/tela_ps_painel"> <button id="voltar">Voltar</button></NavLink>
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
            </Grid>
          </Grid>
        </div>

        <Grid container spacing={0} direction="row" justify="left" alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
            <div id="main-RI-Consulta-Pendente">
              <h1 id="title">Prontuário da Consulta</h1>
              <br></br>

            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}

/*

-------------------------------------Code Original--------------------------------------


export default class FormsAgendamento extends React.Component {

    state = {
        exames: [],
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = async () => {
        const { id } = this.props.match.params;
        console.log(id);
        const request = await api.get(`/exam/${id}`, {headers: {'x-access-token': token}});
        console.log(request);
        console.log(request.data);
        this.setState({ exames: request.data });

      };

    render() {
        return (
        <>
        <SideNav />
        <div id="top-PS">
        <Grid container spacing={0} direction="row" justify="left"  alignItems="center" style={{ marginTop: '-35vh'}}>
          <Grid item xs={2} sm={2} md={1} lg={1} align="center">
                <NavLink id="voltar-a" to="/tela_ps_painel"> <button id="voltar">Voltar</button></NavLink>
            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
          </Grid>
        </Grid>
        </div>

          <Grid container spacing={0} direction="row" justify="left"  alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
          <div id="main-RI-Consulta-Pendente">
          <h1 id="title">Consulta Passada</h1>
          <br></br>
          <div id="lista-style">
          {this.state.exames.map(details => (
          <>
            <div id="exam">

              <h1 id="tittle-forms-cme">Informações da Instituição</h1>
              <hr id="coloring_line"/>
              <GetAgent agent_id={details.agent_id}/>
              <hr id="coloring_line"/>
              <br></br>

              <h1 id="tittle-forms-cme">Informações da Consulta</h1>
              <hr id="coloring_line"/>
              <p id="RI-Title-Cadastro-Paciente">Finalidade de Atendimento:</p><p>{details.appointment_type}</p>
              <p id="RI-Title-Cadastro-Paciente">Especialidade: </p><p>{details.medical_appointment_type}</p>
              <p id="RI-Title-Cadastro-Paciente">Proposta: </p><p>{details.appointment_purpose}</p>
              <p id="RI-Title-Cadastro-Paciente">Turno de atendimento: </p><p>{details.appointment_period}</p>
              <p id="RI-Title-Cadastro-Paciente">Data/Hora:</p><p>{details.date}</p>
              <p id="RI-Title-Cadastro-Paciente">Obervações:</p><p>{details.notes}</p>
              <hr id="coloring_line"/>
              <br></br>

              <h1 id="tittle-forms-cme">Informações do Paciente</h1>
              <hr id="coloring_line"/>
              <br></br>
              <hr id="line-dashed-separator"></hr>
              <h3 id="specific-tittle-small">Dados do Paciente</h3>
              <GetUser user_id={details.user_id}/>
              <hr id="coloring_line"/>
              <br></br>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <NavLink to="/"><button id="PS">Editar Notas da Consulta</button></NavLink>
              </div>

              </div>
              <br></br>
            </>
          ))}
        </div>
        </div>
        </Grid>
        </Grid>
      </>
        );
    }
}

 */
